<template>
    <v-container class="fill-height">
        <v-row v-if="mainCategories.length > 0" align="center" style="min-height: 50%;" class="mb-auto">
            <v-col cols="" v-for="mainCategory in mainCategories" :key="mainCategory.id" align="center">
                <SubCategoryCard :subCategory="mainCategory" @select="selectSubCategory" />
            </v-col>
        </v-row>
        <v-row v-else align="center" style="min-height: 50%;" class="mb-auto">
            <v-col cols="12" class="text-center">
                {{ $t("Loading") }}
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import SubCategoryCard from "../components/SubCategoryCard.vue";

export default {
    name: "ProductCatalogHome",
    components: {
        SubCategoryCard,
    },
    computed: {
        ...mapGetters({
            mainCategories: "catalog/mainCategories",
        }),
    },
    methods: {
        selectSubCategory(subCategory) {
            this.$router.push({ name: 'ProductCategory', params: { id: subCategory.id } });
        },
    },
};
</script>